// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"f7f9516e","498":"da46838b","513":"1cd255bf","705":"8e963c16","789":"e06ab05b"}[chunkId] + ".chunk.js";
};